import { render } from "./pos-preference.vue?vue&type=template&id=4d49cb1d"
import script from "./pos-preference.vue?vue&type=script&lang=js"
export * from "./pos-preference.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__